import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Home from "../pages/Student/Home";
import Detail from "../pages/Student/Detail";

const Student = () => {
  return (
    <div className="Student">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<Detail />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Student;
